// libs
import React from 'react';
import PropTypes from 'prop-types';
import { Multiselect } from 'react-widgets';
import 'react-widgets/dist/css/react-widgets.css';

// component
import Drawer from '../../../../tools/drawer/Drawer';
import Checkbox from '../../../../forms/fields/checkbox/Checkbox';

function SearchFilter(props) {
  const { filter, updateSelectArtist, selectArtist } = props;
  return (
    <div className="filters">
      {filter.filters
      .filter((uniqueFilter) => uniqueFilter.slug !== 'artist-term')
      .map((uniqueFilter) =>
        <React.Fragment key={uniqueFilter.slug}>
          { uniqueFilter.categories &&
            <Drawer title={uniqueFilter.name}>
              { uniqueFilter.categories
              .map((category) =>
                <React.Fragment key={category.slug}>
                  { category.children.length !== 0 ?
                    <div className="filter__checkbox">
                      <span className="filter__checkbox__parent">{category.name}</span>
                      { category.children.map((child) =>
                        <Checkbox
                          name={`${uniqueFilter.slug}__${child.slug}`}
                          id={child.slug}
                          component="input"
                          type="checkbox"
                          key={child.slug}
                          label={child.name}
                        />,
                      )}
                    </div>
                    :
                    <div className="filter__checkbox">
                      <Checkbox
                        name={`${uniqueFilter.slug}__${category.slug}`}
                        id={category.slug}
                        component="input"
                        type="checkbox"
                        label={category.name}
                      />
                    </div>
                  }
                </React.Fragment>,
              )}
            </Drawer>
          }
        </React.Fragment>,
      )}
      {filter.filters
        .filter((uniqueFilter) => uniqueFilter.slug === 'artist-term')
        .map((uniqueFilter) =>
          <React.Fragment key={uniqueFilter.slug}>
            { uniqueFilter.categories &&
            <Drawer title={uniqueFilter.name} className="drawer__content--artist">
              <Multiselect
                onChange={(value) => updateSelectArtist(value)}
                data={uniqueFilter.categories.map(category => category.name)}
                defaultValue={selectArtist}
                value={selectArtist}
                filter="contains"
              />
            </Drawer>
            }
          </React.Fragment>,
      )}
    </div>
  );
}

SearchFilter.contextTypes = {
  t: PropTypes.func,
};

SearchFilter.propTypes = {
  filter: PropTypes.object.isRequired,
  selectArtist: PropTypes.array.isRequired,
  updateSelectArtist: PropTypes.func.isRequired,
};

export default SearchFilter;



// WEBPACK FOOTER //
// ./src/app/components/pages/search/form/parts/SearchFilter.js